import { useSearchParams } from 'react-router-dom';
import { useTenantKey } from '../../lib/useTenantKey';
import { GenerateMediaModal } from './GenerateMediaModal';

/**
 * Site-wide host for the "Generate media" modal, driven by the `?generate=media` search param so it
 * can be opened from anywhere (e.g. the New Content menu, CreateContentButton) without navigating away.
 * Mounted once in the app shell (WorkspaceGate). Generated assets land in the Media Library root.
 */
export function GenerateMediaModalHost() {
  const [params, setParams] = useSearchParams();
  const tenantKey = useTenantKey();
  const open = params.get('generate') === 'media';

  const close = () => {
    const next = new URLSearchParams(params);
    next.delete('generate');
    setParams(next, { replace: true });
  };

  if (!open) return null;
  return <GenerateMediaModal open onClose={close} tenantKey={tenantKey} />;
}
